import Payoffline from './Payoffline';
import Modal from 'react-bootstrap/Modal';
const ModalPayoffline = ({ isModalOpen, params, remittanceRate, closeModal }) => {
  console.log(isModalOpen);
  return (
    <>
      <Modal id='customModal' show={isModalOpen} onHide={closeModal} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>Choosing to make an offline payment?
          <p className="">Please refer to the bank account details provided below.</p>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <Payoffline bankId={params?.bankid} remmitanceData={remittanceRate} closeModal={closeModal} />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ModalPayoffline;
